import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';

export default function useDealers(props) {

    const {
        data: dealers,
        isLoading: loadingDealers,
        error: errorDealers,
        refetch: refetchDealers,
    } = useProtectedQuery({
        queryKey: ['get_dealers',],
        queryFn: async () => {
            let url = `/api/dealer/get-dealers`;


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting dealers");
            }

        },
    });


    return {
        dealers,
        loadingDealers,
        errorDealers,
        refetchDealers,
    }
}
